import React, { useState } from "react";
import { VariationSectionImg } from "../../assets";
import styles from './index.module.css';
import { useMotionValueEvent, useScroll } from "framer-motion";
import { EngineCard, Sparkels } from "../../Components";
import { Explore } from "..";

const Features = (props) => {

    const [scrollPos, setScrollPos] = useState(0);
    const { scrollY } = useScroll();

    useMotionValueEvent(scrollY, "change", (latest) => {
        latest < 400 && setScrollPos(latest);
      });
    
    return (
      <div >
      <div className={`${styles["hero-spacer"]}`} />
      <div
        key={scrollPos}
        className={`${styles["content-section"]}`}
      >
        <h3 className={`${styles.title}`}>
          Write Variations Like Never Before
        </h3>
        <Sparkels />
        <p className={`${styles.subp} pb-5`}>
          Enjoy the best learning experience with our new way to write your variations.
          Our platform will help you create your ultimate chess openings book.
          Take your chess skills to the next level for free !
        </p>
        <div className="flex items-center justify-center w-full">
        <div className={`${styles.imgContainer} flex items-center justify-center w-[85%] min-w-[350px] w-[36em] py-[3%]`}>
        <img src={VariationSectionImg} className="rounded w-[95%] "/>
        </div>
        </div>
        <br />
        <p className={`${styles.subp}`}>
          Annotate your variations with all the common annotations and go multiple levels deep into your variations with amazing navigation abilities.
        </p>
      </div>
      
        </div>
    )
}

export default Features;